import { prop } from 'datx';

import { AddOn } from './AddOn';
import { Avatar } from './Avatar';
import { Banner } from './Banner';
import { BaseModel } from './BaseModel';
import { Font } from './Font';
import { Magic } from './Magic';
import { Page } from './Page';
import { Wrap } from './Wrap';

type Translation = Record<string, Record<string, string>>;

export class Book extends BaseModel {
  public static type = 'book';

  @prop
  public width!: number;

  @prop
  public price!: number;

  @prop
  public height!: number;

  @prop
  public coverHeight!: number;

  @prop
  public coverWidth!: number;

  @prop
  public pageCount!: number;

  @prop
  public languages!: Array<string>;

  @prop.toMany(Font)
  public fonts!: Array<Font>;

  @prop.toMany(Avatar)
  public avatars!: Array<Avatar>;

  @prop.toOne(Banner)
  public banners!: Banner;

  @prop.toMany(AddOn)
  public extraProducts!: Array<AddOn>;

  @prop.toMany(Wrap)
  public wraps!: Array<Wrap>;

  @prop
  public translations!: Translation;

  @prop
  public pageImages!: Array<Page>;

  @prop.toMany(Magic)
  public moreMagic!: Array<Magic>;

  @prop
  public elementConfigurations!: Translation;
}
